<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="38" label="游戏">
          <el-select
            v-model="formData.gameIds"
            :popper-append-to-body="false"
            clearable
            multiple
            collapse-tags
            filterable
            placeholder="全部"
            style="width: 200px"
          >
            <el-option v-for="pro in POPULAR_GAMES" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="游戏组">
          <el-select
            v-model="formData.gameGroupIds"
            :popper-append-to-body="false"
            style="width: 200px"
            clearable
            multiple
            collapse-tags
            filterable
            placeholder="全部"
          >
            <el-option v-for="opt in GAME_GROUPS" :key="opt.id" :label="opt.name" :value="opt.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="项目组">
          <el-select v-model="formData.projectGroupId" :popper-append-to-body="false" clearable placeholder="全部" style="width: 160px">
            <el-option v-for="pro in PROJECT_GROUP" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
          </el-select>
        </ElFormItem>

        <el-form-item label="素材样式">
          <el-cascader
            v-model="formData.imageStyles"
            clearable
            filterable
            collapse-tags
            style="width: 190px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="IMAGE_STYLE_TAG_TREE"
          >
          </el-cascader>
        </el-form-item>

        <ElFormItem label="上传时间">
          <slot name="date"> </slot>
        </ElFormItem>

        <ElFormItem class="bg-transparent" label-width="0">
          <div>
            <ElButton type="primary" @click="onQuery">查询</ElButton>
            <ElButton :loading="exportLoading" @click="$emit('export')">数据导出</ElButton>
            <slot name="sync"></slot>
            <ElButton @click="$emit('custom-col')">自定义列</ElButton>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { initPageData, PROJECT_GROUP, GAME_GROUPS, POPULAR_GAMES, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, GAME_GROUPS, POPULAR_GAMES, IMAGE_STYLE_TAG_TREE])
const getFormData = () => {
  return {
    gameIds: [],
    gameGroupIds: [],
    imageStyles: [],
    projectGroupId: ''
  }
}
export default {
  name: 'PlannerFilter',
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  mounted() {
    // 外部列表的查询是由top-datepick组件触发 -_-; 先不改了，判断是否有date slot ,触发一下查询
    const { date } = this.$slots
    if (date) this.onQuery()
  },
  data() {
    return {
      formData: getFormData()
    }
  },
  methods: {
    onQuery() {
      this.$emit('change')
    },
    buildParams() {
      const { imageStyles, ...rest } = this.formData
      const imageStyleIds = imageStyles.length ? imageStyles.map((i) => i.slice(-1)).flat() : []
      return {
        ...rest,
        labelIdsStr: imageStyleIds?.length ? imageStyleIds.join(',') : undefined
      }
    }

    // 废弃
    // getTransferedTaskQueryConditions(extraParams, pageType) {
    //   return transferTaskQueryConditions.call(this, { ...this.formData, ...extraParams }, pageType)
    // }
  }
}
</script>
